import { navigation, React } from '@/config'
import { AppStatus } from '@/redux'
import { APIClient } from '@/services'
import { onMount, onUpdate, useUnmount, waitFor } from '@codeleap/common'
import { AuthErrors } from './errors'
import { QueryKeys } from './queryKeys'
import { firebase } from '@/services/firebase'

export function useVerifyEmail(root = false) {
  const [isEmailVerified, setIsEmailVerified] = React.useState(false)
  const intervalEmailCheck = React.useRef(null)
  const { profile } = APIClient.Session.useSession()

  const cancelEmailCheck = () => {
    if (intervalEmailCheck.current != null) {
      clearInterval(intervalEmailCheck.current)
      intervalEmailCheck.current = null
    }
  }

  const registryEmailCheck = () => {
    if (intervalEmailCheck.current == null) {
      intervalEmailCheck.current = setInterval(() => {
        checkEmail()
      }, 1000)
    }
  }

  async function resendEmailConfirmation() {
    AppStatus.set('loading')

    

    try {
      await firebase.auth.sendEmailVerification(
        firebase.auth.currentUser
      )

      AppStatus.set('done')
    } catch (err) {
      AppStatus.set('idle')
      AuthErrors.onError(err, 'Resend email - useVerifyEmail')
    }
  }

  const checkEmail = async () => {
    
    let user = firebase.auth.currentUser

    if (!user) {
      return
    }

    firebase.auth.currentUser?.reload?.()

    user = firebase.auth.currentUser

    if (user?.emailVerified) {
      setIsEmailVerified(true)
      cancelEmailCheck()
    }
  }

  onUpdate(() => {
    if (root && isEmailVerified) {
      cancelEmailCheck()
    }
  }, [isEmailVerified])

  onMount(() => {
    if (root) {
      registryEmailCheck()
    }
  })

  useUnmount(() => {
    if (root) {
      cancelEmailCheck()
    }
  })

  const cancelVerification = async () => {
    cancelEmailCheck()

    AppStatus.set('splash')

    await waitFor(250)

    navigation.navigate('Home')

    APIClient.Session.deleteProfile(profile?.id)
    QueryKeys.me.setData(null)

    await waitFor(1500)

    firebase.auth.signOut()

    AppStatus.set('idle')
  }

  return {
    resendEmailConfirmation,
    checkEmail,
    isEmailVerified,
    cancelVerification,
  }
}
